import { LeadForm } from '../components/forms/LeadForm';
import { Mail, Phone, MapPin, Clock, Calendar, Facebook, Instagram, Youtube, MessageSquare } from 'lucide-react';
import { Button } from '../components/ui/button';

const socialLinks = [
  { name: 'Facebook (SeanTheBroker)', url: 'https://www.facebook.com/share/17TFPDfMFA/', icon: Facebook },
  { name: 'Facebook (Sean South Florida)', url: 'https://www.facebook.com/profile.php?id=61574448566441&sk=about', icon: Facebook },
  { name: 'Instagram (Straight4TheTop)', url: 'https://www.instagram.com/straight4thetop2', icon: Instagram },
  { name: 'Instagram (SeanTheBroker)', url: 'https://www.instagram.com/seanthebroker1', icon: Instagram },
  { name: 'YouTube', url: 'https://www.youtube.com/@seanmcclain2855', icon: Youtube },
  { name: 'TikTok', url: 'https://www.tiktok.com/@straight4thetop', icon: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
    </svg>
  )},
];

export const Contact = () => {
  return (
    <div data-testid="contact-page">
      {/* Hero Section */}
      <section className="py-24 bg-[#0a0a0a]" data-testid="contact-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <p className="section-overline">Contact Us</p>
            <h1 className="text-4xl sm:text-5xl font-light text-[#F5F5F0] mt-4 mb-6" style={{ fontFamily: 'Playfair Display' }}>
              Get In <span className="text-gold-gradient">Touch</span>
            </h1>
            <p className="text-lg text-[#808080] max-w-2xl mx-auto">
              Ready to make your move? I'm here to help. Reach out today and let's start the conversation.
            </p>
            {/* Prominent click-to-call */}
            <div className="mt-8">
              <a href="tel:7863560878">
                <Button className="btn-gold px-10 py-5 text-lg font-bold" data-testid="contact-hero-call">
                  <Phone className="w-6 h-6 mr-3" /> (786) 356-0878
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info & Form */}
      <section className="py-16 bg-[#111111]" data-testid="contact-form-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div>
              <h2 className="section-title mb-8">Contact Information</h2>
              
              <div className="space-y-6 mb-8">
                <a href="tel:7863560878" className="flex items-start group" data-testid="contact-phone-link">
                  <div className="w-12 h-12 rounded-full bg-[#D4AF37]/10 flex items-center justify-center mr-4 flex-shrink-0">
                    <Phone className="w-5 h-5 text-[#D4AF37]" />
                  </div>
                  <div>
                    <h4 className="text-[#F5F5F0] font-medium mb-1">Call Us</h4>
                    <span className="text-[#D4AF37] hover:text-[#E5C04B] transition-colors text-lg font-semibold">
                      (786) 356-0878
                    </span>
                  </div>
                </a>

                <a href="sms:7863560878" className="flex items-start group" data-testid="contact-text-link">
                  <div className="w-12 h-12 rounded-full bg-[#D4AF37]/10 flex items-center justify-center mr-4 flex-shrink-0">
                    <MessageSquare className="w-5 h-5 text-[#D4AF37]" />
                  </div>
                  <div>
                    <h4 className="text-[#F5F5F0] font-medium mb-1">Text Us</h4>
                    <span className="text-[#D4AF37] hover:text-[#E5C04B] transition-colors text-lg font-semibold">
                      (786) 356-0878
                    </span>
                  </div>
                </a>

                <div className="flex items-start">
                  <div className="w-12 h-12 rounded-full bg-[#D4AF37]/10 flex items-center justify-center mr-4 flex-shrink-0">
                    <MapPin className="w-5 h-5 text-[#D4AF37]" />
                  </div>
                  <div>
                    <h4 className="text-[#F5F5F0] font-medium mb-1">Location</h4>
                    <p className="text-[#808080]">South Florida</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-12 h-12 rounded-full bg-[#D4AF37]/10 flex items-center justify-center mr-4 flex-shrink-0">
                    <Mail className="w-5 h-5 text-[#D4AF37]" />
                  </div>
                  <div>
                    <h4 className="text-[#F5F5F0] font-medium mb-1">Email</h4>
                    <a href="mailto:info@simplerealtyandinvestments.com" className="text-[#808080] hover:text-[#D4AF37] transition-colors">
                      info@simplerealtyandinvestments.com
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-12 h-12 rounded-full bg-[#D4AF37]/10 flex items-center justify-center mr-4 flex-shrink-0">
                    <Clock className="w-5 h-5 text-[#D4AF37]" />
                  </div>
                  <div>
                    <h4 className="text-[#F5F5F0] font-medium mb-1">Business Hours</h4>
                    <p className="text-[#808080]">Mon - Sat: 9:00 AM - 7:00 PM</p>
                    <p className="text-[#808080]">Sun: By Appointment</p>
                  </div>
                </div>
              </div>

              {/* Quick Actions */}
              <div className="space-y-3 mb-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <a href="tel:7863560878"><Button className="btn-gold w-full" data-testid="contact-call-btn"><Phone className="w-4 h-4 mr-2" /> Call Now</Button></a>
                  <a href="sms:7863560878"><Button className="btn-gold w-full" data-testid="contact-text-btn"><MessageSquare className="w-4 h-4 mr-2" /> Text Us</Button></a>
                </div>
              </div>

              {/* Social Links */}
              <div>
                <h4 className="text-[#F5F5F0] font-medium mb-4">Connect With Us</h4>
                <div className="flex flex-wrap gap-3">
                  {socialLinks.map((social) => (
                    <a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer" className="social-icon" title={social.name} data-testid={`contact-social-${social.name.toLowerCase().replace(/[^a-z]/g, '-')}`}>
                      <social.icon className="w-4 h-4" />
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <LeadForm 
              source="contact"
              title="Send Us a Message"
              subtitle="Fill out the form below and we'll get back to you within 24 hours."
              buttonText="Send Message"
              showMessage={true}
              showPropertyInterest={true}
            />
          </div>
        </div>
      </section>

      {/* Book an Appointment */}
      <section className="py-16 bg-[#0a0a0a]" data-testid="contact-booking-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="bg-gradient-to-r from-[#D4AF37]/10 to-[#D4AF37]/5 border border-[#D4AF37]/30 rounded-2xl p-8 sm:p-12 text-center">
            <Calendar className="w-12 h-12 text-[#D4AF37] mx-auto mb-4" />
            <h2 className="text-3xl sm:text-4xl font-light text-[#F5F5F0] mb-3" style={{ fontFamily: 'Playfair Display' }}>
              Book an <span className="text-gold-gradient">Appointment</span>
            </h2>
            <p className="text-[#808080] max-w-xl mx-auto mb-8">
              Skip the back and forth. Pick a time that works for you and I'll be there — whether it's a property showing, consultation, or strategy session.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <a href="https://calendly.com/seantherealtor/15min" target="_blank" rel="noopener noreferrer">
                <Button className="btn-gold px-8 py-4 text-base font-semibold" data-testid="contact-calendly-btn">
                  <Calendar className="w-5 h-5 mr-2" /> Schedule a 15-Min Consultation
                </Button>
              </a>
              <a href="tel:7863560878">
                <Button variant="outline" className="btn-outline-gold px-8 py-4 text-base" data-testid="contact-call-direct">
                  <Phone className="w-5 h-5 mr-2" /> Or Call (786) 356-0878
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
